import { useState, useEffect } from "react";
import { Form, Button, Col, Row, Container, Modal } from "react-bootstrap";
import "./HorariosModal.css";
import { doc, updateDoc } from "firebase/firestore";
import { projectFirestore } from "../../../../firebase/config";

const HorariosModal = ({ menu, show, mod, item, handleClose }) => {
  const dias = [
    "lunes",
    "martes",
    "miercoles",
    "jueves",
    "viernes",
    "sabado",
    "domingo",
  ];
  const modo = ["NORMAL", "PREVENTA", "RECOGER CON HORARIO"];
  const [horarios, setHorarios] = useState({});

  useEffect(() => {
    if (show) {
      if (mod) {
        if (item?.rapido && (!item.rapido.inicial || !item.rapido.inicial)) {
          item.rapido.inicial = "0";
          item.rapido.final = "0";
        } else if (!item?.rapido) {
          item.rapido = {
            inicial: "0",
            final: "0",
          };
        }
        setHorarios(item);
      }
    }
  }, [item, mod, show]);

  const handleChange = (e) => {
    setHorarios({
      ...horarios,
      [e.target.name]: {
        ...horarios[e.target.name],
        [e.target.id]: e.target.value,
      },
    });
  };

  const handleChangeSwitch = (e) => {
    setHorarios({
      ...horarios,
      [e.target.id]: {
        ...horarios[e.target.id],
        active: e.target.checked,
      },
    });
  };

  const handleChangeSwitchP = (e) => {
    setHorarios({
      ...horarios,
      [e.target.id]: e.target.checked,
    });
  };

  const handleChangeValue = (e) => {
    setHorarios({
      ...horarios,
      [e.target.id]: e.target.value,
    });
  };

  const handleCloseLocal = async () => {
    //setCategoria(null);
    // setImageUrl(null);
    // setImage(null);
    setHorarios({});
    handleClose();
  };

  const selectItem = (e) => {
    let nhorarios = { ...horarios };
    if (
      e.target.id === "final" ||
      e.target.id === "inicial" ||
      e.target.id === "hinicial" ||
      e.target.id === "hfinal"
    ) {
      nhorarios.rapido = {
        ...horarios.rapido,
        [e.target.id]: e.target.value,
      };
      if (
        nhorarios &&
        nhorarios.rapido &&
        nhorarios.rapido.inicial &&
        nhorarios.rapido.final &&
        nhorarios.rapido.hinicial &&
        nhorarios.rapido.hfinal
      ) {
        if (
          parseInt(nhorarios.rapido.inicial) > parseInt(nhorarios.rapido.final)
        ) {
          dias.forEach((value, index) => {
            if (
              index >= parseInt(nhorarios.rapido.inicial) ||
              index <= parseInt(nhorarios.rapido.final)
            ) {
              nhorarios[value] = {
                ...horarios[value],
                active: true,
                inicio: nhorarios.rapido.hinicial,
                fin: nhorarios.rapido.hfinal,
              };
            } else {
              nhorarios[value] = {
                ...horarios[value],
                active: false,
              };
            }
          });
        } else if (
          parseInt(nhorarios.rapido.inicial) < parseInt(nhorarios.rapido.final)
        ) {
          dias.forEach((value, index) => {
            if (
              (index > parseInt(nhorarios.rapido.inicial) &&
                index < parseInt(nhorarios.rapido.final)) ||
              index === parseInt(nhorarios.rapido.inicial) ||
              index === parseInt(nhorarios.rapido.final)
            ) {
              nhorarios[value] = {
                ...horarios[value],
                active: true,
                inicio: nhorarios.rapido.hinicial,
                fin: nhorarios.rapido.hfinal,
              };
            } else {
              nhorarios[value] = {
                ...horarios[value],
                active: false,
              };
            }
          });
        } else {
          dias.forEach((value, index) => {
            if (index === parseInt(nhorarios.rapido.inicial)) {
              nhorarios[value] = {
                ...horarios[value],
                active: true,
                inicio: nhorarios.rapido.hinicial,
                fin: nhorarios.rapido.hfinal,
              };
            } else {
              nhorarios[value] = {
                ...horarios[value],
                active: false,
              };
            }
          });
        }
      }
    } else {
      nhorarios = {
        ...horarios,
        [e.target.id]: e.target.value,
      };
    }
    setHorarios(nhorarios);
  };

  const save = async () => {
    if (mod === "UPD") {
      let bandera = 0;
      dias.forEach((item, index) => {
        if (
          horarios &&
          (horarios.modo === "PREVENTA" ||
            horarios.modo === "RECOGER CON HORARIO") &&
          horarios[item]?.active
        ) {
          if (!horarios[item].fin || !horarios[item].inicio) {
            bandera++;
          } else {
            let horaIni = parseInt(horarios[item].inicio.split(":")[0]);
            let miniIni = parseInt(horarios[item].inicio.split(":")[1]);
            let horaFin = parseInt(horarios[item].fin.split(":")[0]);
            let miniFin = parseInt(horarios[item].fin.split(":")[1]);
            if (
              horaIni > horaFin ||
              (horaFin === horaIni && miniIni > miniFin)
            ) {
              bandera++;
            }
          }
        }
      });
      if (bandera > 0) {
        alert(
          "Ingrese una la hora de inicio y fin validos en los dias habilitados.",
        );
        return;
      }
      if (
        horarios.limite &&
        (!horarios.piezas || parseInt(horarios.piezas) <= 0)
      ) {
        alert("Ingrese una cantidad de piezas valida.");
        return;
      }
      if (
        (horarios.modo === "PREVENTA" ||
          horarios.modo === "RECOGER CON HORARIO") &&
        (!horarios.maxOrd || !horarios.estimado || !horarios.intOrd)
      ) {
        alert('Complete la informacion para "Tiempo estimado de preparacion"');
        return;
      }
      if (
        (horarios.modo === "PREVENTA" ||
          horarios.modo === "RECOGER CON HORARIO") &&
        (parseInt(horarios.maxOrd) <= 0 ||
          parseInt(horarios.estimado) <= 0 ||
          parseInt(horarios.intOrd) <= 0)
      ) {
        alert(
          'Ingrese informacion valida para "Tiempo estimado de preparacion"',
        );
        return;
      }
      horarios.categoria = doc(
        projectFirestore,
        "menu",
        menu.id,
        "categoria",
        horarios.categoria.id,
      );
      updateDoc(
        doc(projectFirestore, "menu", menu.id, "platillo", item.id),
        horarios,
      );
      handleCloseLocal();
    }
  };

  return (
    <Modal show={show} onHide={handleCloseLocal} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>HORARIOS DEL PLATILLO</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Form>
            <Row style={{ justifyContent: "center" }}>
              <Row style={{ alignItems: "center", justifyContent: "center" }}>
                <Col md={3}>
                  <label>MODO DE VENTA:</label>
                </Col>
                <Col md={4}>
                  <Form.Select
                    id="modo"
                    onChange={selectItem}
                    value={horarios?.modo ? horarios?.modo : "Normal"}
                  >
                    {modo.map((item, index) => {
                      return <option value={item}>{item}</option>;
                    })}
                  </Form.Select>
                </Col>
              </Row>
              <hr />
              TIEMPO ESTIMADO DE PREPARACION:
              <br />
              <Row
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 10,
                  marginTop: 10,
                }}
              >
                <Col md={9}>
                  <Row>
                    <Col md={4}>
                      Se prepara en:
                      <input
                        style={{ width: "50%", minWidth: 2 }}
                        type="number"
                        placeholder="30"
                        id="estimado"
                        onChange={handleChangeValue}
                        value={horarios.estimado}
                      />
                      minutos
                    </Col>
                    <Col md={8} style={{ textAlign: "center" }}>
                      Maximo de ordenes por intervalo:
                      <br />
                      <input
                        style={{ width: "20%", minWidth: 2 }}
                        type="number"
                        id="maxOrd"
                        onChange={handleChangeValue}
                        value={horarios.maxOrd}
                        placeholder="5"
                      />
                      ordenes en
                      <input
                        style={{ width: "20%", minWidth: 2 }}
                        type="number"
                        placeholder="5"
                        id="intOrd"
                        onChange={handleChangeValue}
                        value={horarios.intOrd}
                      />
                      minutos
                    </Col>
                  </Row>
                </Col>
                <Col md={3}>
                  <Row style={{ justifyContent: "space-evenly" }}>
                    Mostrar mensaje de "Listo en X minutos"
                    <input
                      id="mensaje"
                      onChange={handleChangeSwitchP}
                      checked={horarios.mensaje}
                      type="checkbox"
                      className="form-check-input"
                      style={{
                        width: "1em",
                        appearance: "auto",
                        margin: "10px !important",
                      }}
                    ></input>
                  </Row>
                </Col>
              </Row>
              <hr />
              PIEZAS DISPONIBLES POR DIA:
              <br />
              <Row
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 10,
                  marginTop: 10,
                }}
              >
                <Col md={6}>
                  <Row
                    style={{
                      textAlign: "center",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Col md={8}>Habilitar limite de piezas:</Col>
                    <Col md={1}>
                      <input
                        id="limite"
                        onChange={handleChangeSwitchP}
                        checked={horarios.limite}
                        type="checkbox"
                        className="form-check-input"
                        style={{
                          width: "1em",
                          appearance: "auto",
                          margin: "10px !important",
                        }}
                      ></input>
                    </Col>
                  </Row>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col md={12}>
                      Piezas por dia:
                      <input
                        style={{
                          width: "25%",
                          minWidth: 2,
                        }}
                        type="number"
                        disabled={!horarios.limite}
                        placeholder="50"
                        id="piezas"
                        onChange={handleChangeValue}
                        value={horarios.piezas}
                      />
                      Pz
                    </Col>
                  </Row>
                </Col>
              </Row>
              {(horarios?.modo === "PREVENTA" ||
                horarios?.modo === "RECOGER CON HORARIO") && (
                <>
                  <hr />
                  OPCIONES RAPIDAS:
                  <Row
                    style={{
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: 10,
                    }}
                  >
                    <Col md={6}>
                      <Row>
                        <Col md={6}>
                          Dia inicial:
                          <Form.Select
                            id="inicial"
                            onChange={selectItem}
                            value={
                              horarios?.rapido?.inicial
                                ? horarios?.rapido?.inicial
                                : 0
                            }
                          >
                            {dias.map((item, index) => {
                              return (
                                <option value={index}>
                                  {item.toUpperCase()}
                                </option>
                              );
                            })}
                          </Form.Select>
                        </Col>
                        <Col md={6}>
                          Dia final:
                          <Form.Select
                            id="final"
                            onChange={selectItem}
                            value={
                              horarios?.rapido?.final
                                ? horarios?.rapido?.final
                                : 0
                            }
                          >
                            {dias.map((item, index) => {
                              return (
                                <option value={index}>
                                  {item.toUpperCase()}
                                </option>
                              );
                            })}
                          </Form.Select>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={6}>
                      <Row>
                        <Col md={6}>
                          De:
                          <input
                            type="time"
                            id="hinicial"
                            onChange={selectItem}
                            value={horarios?.rapido?.hinicial}
                          />
                        </Col>
                        <Col md={6}>
                          a:
                          <input
                            type="time"
                            id="hfinal"
                            onChange={selectItem}
                            value={horarios?.rapido?.hfinal}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <hr />
                  <Row
                    style={{ alignItems: "center", justifyContent: "center" }}
                  >
                    <Col md={5}>EDITAR MANUAL</Col>
                    <Col md={2}>
                      <input
                        id="personalizar"
                        onChange={handleChangeSwitchP}
                        checked={horarios.personalizar}
                        type="checkbox"
                        className="form-check-input"
                        style={{ width: "1em", appearance: "auto" }}
                      ></input>
                    </Col>
                  </Row>
                  {horarios?.personalizar &&
                    dias.map((item, key) => {
                      return (
                        <Col md={6}>
                          <Row style={{ alignItems: "center" }}>
                            <Col md={6}>
                              <label>{item.toUpperCase()}</label>
                            </Col>
                            <Col md={6}>
                              <input
                                id={item}
                                onChange={handleChangeSwitch}
                                checked={horarios[item]?.active}
                                type="checkbox"
                                className="form-check-input"
                                style={{ width: "1em", appearance: "auto" }}
                              ></input>
                            </Col>
                          </Row>
                          {horarios[item]?.active ? (
                            <Row>
                              <Col md={6}>
                                Inicio:
                                <input
                                  type="time"
                                  id="inicio"
                                  name={item}
                                  onChange={handleChange}
                                  value={horarios[item].inicio}
                                />
                              </Col>
                              <Col md={6}>
                                Fin:
                                <input
                                  type="time"
                                  id="fin"
                                  name={item}
                                  value={horarios[item].fin}
                                  onChange={handleChange}
                                />
                              </Col>
                            </Row>
                          ) : (
                            <></>
                          )}
                        </Col>
                      );
                    })}
                </>
              )}
            </Row>
          </Form>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseLocal}>
          CANCELAR
        </Button>
        <Button
          variant={mod && mod === "DLT" ? "danger" : "primary"}
          onClick={save}
        >
          {mod && mod === "DLT" ? "ELIMINAR" : "GUARDAR"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default HorariosModal;
